import { palette } from "./palette";

export const checkbox = {
  root: {
    color: "#484848",
    "&$checked": {
      color: palette.primary.main
    }
  },
  colorPrimary: {
    color: "#484848",
    "&$checked": {
      color: palette.primary.main
    }
  },
  colorSecondary: {
    color: "#484848",
    "&$checked": {
      color: palette.primary.main
    }
  }
};
